<template>
  <div id="app" class="router-view-box">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import WebIM from "./utils/WebIM";

export default {
	name: 'App',
	provide() {
		return {
			reload: this.reload
		}
	},
	data() {
		return {
			isRouterAlive: true
		}
	},
  beforeMount(){

	},
	methods: {
		reload() {
			this.isRouterAlive = false;
			this.$nextTick(function() {
				this.isRouterAlive = true;
			})
		}
	},
}
</script>
<style lang="less">
  html,body,.router-view-box {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue